export enum SignupErrorKey {
  InvalidId = 'Invalid Id',
  NoResponseUrl = 'No response url',
  EntityAlreadyExists = 'The entity name already exists',
  EntityNameIsEmpty = 'The entity name can not be empty',
}
